"use client"

import { useState, useEffect } from "react"
import { apiFetch } from "@/lib/api/apiFetch"

export interface UserDetails {
  mfa: {
    backupCodes: string[]
    passkeyEnabled: boolean
    passkeys: any[]
    totpEnabled: boolean
    totpVerified: boolean
  }
  _id: string
  name: string
  email: string
  source: string
  orgId: {
    _id: string
    name: string
    registerNumber: string
    orgId: string
  }
  role: string
  enabled: number
  settings?: {
    notifications?: {
      email: boolean
      push: boolean
      successSound: string
      errorSound: string
    }
  }
  createdAt: string
  updatedAt: string
  __v: number
}

export function useUser() {
  const [user, setUser] = useState<UserDetails | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<any>(null)

  const fetchUserDetails = async () => {
    try {
      setLoading(true)
      const data = await apiFetch("/api/users/details")
      setUser(data.data)
      setError(null)
    } catch (err) {
      console.error("Failed to fetch user details:", err)
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUserDetails()
  }, [])

  const updateUserSettings = async (settingsPayload: any) => {
    if (!user?._id) throw new Error("No user ID found")
    try {
      setLoading(true)
      await apiFetch(`/api/users/${user._id}`, {
        method: "PUT",
        data: { settings: settingsPayload }
      })
      await fetchUserDetails()
    } catch (err) {
      console.error("Failed to update user settings:", err)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return { user, loading, error, refetch: fetchUserDetails, updateUserSettings }
}
